import * as d3 from 'd3';
import { HeadingDefinition } from '../logbookTable/HeadingDefinition';
import { AlarmsTableConfiguration } from './alarmsTable.configuration';

export function getAlarmsTableHeadings(configuration: AlarmsTableConfiguration) {
    const headings: HeadingDefinition[] = [];
    headings.push({ label: '', classed: { 'plus-column': true } });
    if (configuration.showGroup) {
        headings.push({ label: 'Group', defaultWidthPercentage: 5 });
    }
    if (configuration.showIdentifier) {
        headings.push({ label: 'Identifier', defaultWidthPercentage: 5 });
    }
    if (configuration.showTag) {
        headings.push({ label: 'Tag', defaultWidthPercentage: 5 });
    }
    if (configuration.showUnit) {
        headings.push({ label: 'Unit', defaultWidthPercentage: 5 });
    }
    if (configuration.showComment) {
        headings.push({ label: 'Comment', defaultWidthPercentage: 5 });
    }
    if (configuration.showNumberOfExcursions) {
        headings.push({ label: 'Number of excursions', defaultWidthPercentage: 5, classed: { 'right-col': true } });
    }
    if (configuration.showExcursionTime) {
        headings.push({ label: 'Total excursion time (h)', defaultWidthPercentage: 5, classed: { 'right-col': true } });
    }
    if (configuration.showMaxDeviation) {
        headings.push({ label: 'Max. deviation', defaultWidthPercentage: 5, classed: { 'right-col': true } });
    }
    if (configuration.showCurrentValue) {
        headings.push({ label: 'Current value', defaultWidthPercentage: 5, classed: { 'right-col': true } });
    }
    if (configuration.parameters) {
        const { parameters } = configuration;
        if (parameters.showLow) {
            headings.push({ label: 'Low', defaultWidthPercentage: 5, classed: { 'right-col': true } });
        }
        if (parameters.showHigh) {
            headings.push({ label: 'High', defaultWidthPercentage: 5, classed: { 'right-col': true } });
        }
        if (parameters.showWeight) {
            headings.push({ label: 'Weight', defaultWidthPercentage: 5, classed: { 'right-col': true } });
        }
        if (parameters.showProbabilityOfFailure) {
            headings.push({ label: 'Probability of failure', defaultWidthPercentage: 5 });
        }
        if (parameters.showConsequenceOfFailure) {
            headings.push({ label: 'Consequence of failure', defaultWidthPercentage: 5 });
        }
        if (parameters.showAction) {
            headings.push({ label: 'Action', defaultWidthPercentage: 5 });
        }
        if (parameters.showCategories) {
            headings.push({ label: 'Categories', defaultWidthPercentage: 5 });
        }
    }
    if (configuration.showTrend) {
        headings.push({ label: 'Trend', classed: { 'sparkline-cell': true } });
    }
    const headingsWithWidth = headings.filter(h => !!h.defaultWidthPercentage);
    const totalWidth = d3.sum(headingsWithWidth, h => h.defaultWidthPercentage);
    headingsWithWidth.forEach(h => {
        h.style = {
            'width': h.defaultWidthPercentage / totalWidth * 100 + '%'
        };
    });
    return headings;
}
